import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../lib/metaPixel';
export function Urgency() {
  return <section className="relative bg-[#18120C] py-[40px] md:py-[64px] px-6 overflow-hidden" data-id="element-269">
      <div className="max-w-[860px] mx-auto text-center" data-id="element-270">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-271">
          {/* Top label */}
          <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-[#FCD34D] mb-6" data-id="element-272">
            ES TU MOMENTO
          </p>

          {/* Main H2 */}
          <h2 className="font-serif font-black text-[36px] md:text-[40px] leading-[1.15] text-[#FAF7F0] mb-8 max-w-[680px] mx-auto" data-id="element-273">
            Si llegaste hasta aquí, ya tomaste la decisión más importante.
          </h2>

          {/* Paragraph 1 */}
          <p className="font-lora italic text-[20px] text-[#D1C9BC] max-w-[600px] mx-auto leading-[1.9] mb-8" data-id="element-274">
            No llegas hasta el final de una página así por accidente. Llegaste
            porque algo dentro de ti sabe que esto te importa. Que tu salud
            importa. Que tú importas.
          </p>

          {/* Paragraph 2 */}
          <p className="font-lora text-[18px] text-[#D1C9BC] max-w-[580px] mx-auto leading-[1.8]" data-id="element-275">
            Todo está en tus manos ahora. La información que tu médico asumió
            que no ibas a entender. El mapa que nadie te dio cuando saliste del
            consultorio. Los años que puedes recuperar si actúas hoy.
          </p>

          {/* Decorative separator */}
          <div className="bg-[#FCD34D]/40 mx-auto" style={{
          width: '40px',
          height: '1px',
          margin: '40px auto'
        }} data-id="element-276"></div>

          {/* Transition H3 */}
          <h3 className="font-serif italic text-[24px] text-[#FCD34D] mb-12 max-w-[620px] mx-auto" data-id="element-277">
            Estás a un solo paso de cambiar tu salud para siempre.
          </h3>

          {/* OFFER BLOCK */}
          <div className="mx-auto text-left" style={{
          backgroundColor: '#0F0A06',
          borderRadius: '16px',
          padding: '48px',
          maxWidth: '560px',
          border: '1px solid rgba(252,211,77,0.2)'
        }} data-id="element-278">
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#FCD34D] mb-4 text-center" data-id="element-279">
              LO QUE RECIBES HOY
            </p>

            <h2 className="font-serif font-black text-[36px] text-[#FAF7F0] text-center mb-3" data-id="element-280">
              4 libros. 1 solo precio.
            </h2>

            <h3 className="font-lora italic text-[20px] text-[#FCA5A5] text-center mb-8" data-id="element-281">
              Tu salud no espera.
            </h3>

            {/* Total row */}
            <div className="flex justify-between items-end mb-2" data-id="element-282">
              <div className="flex flex-col" data-id="element-283">
                <span className="font-mono text-[12px] text-[#687280]" data-id="element-284">
                  Valor total
                </span>
                <span className="font-mono text-[14px] text-[#687280] line-through" data-id="element-285">
                  $56.85
                </span>
              </div>
              <span className="font-serif font-black text-[52px] leading-none text-[#FCD34D]" data-id="element-286">
                $17 USD
              </span>
            </div>

            {/* Anchor text */}
            <p className="font-mono text-[11px] text-[#687280] text-center mt-2 mb-8" data-id="element-287">
              Una consulta médica en USA cuesta entre $150 y $400.
            </p>

            {/* Primary CTA */}
            <a href="https://godeskcore.com/products/el-azucar-silenciosa" onClick={() => trackAddToCart()} className="block w-full text-center text-white font-bold text-[18px] mb-3" style={{
            backgroundColor: '#B91C1C',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 8px 28px rgba(185,28,28,0.4)'
          }} data-id="element-288">
              🛒 SÍ, QUIERO EL MAPA COMPLETO — $17 USD
            </a>

            {/* Microcopy */}
            <p className="font-mono text-[11px] text-[#687280] text-center mb-5" data-id="element-289">
              ✓ Acceso inmediato · 4 PDFs · Garantía 7 días · Sin preguntas
            </p>

            {/* Secondary link */}
            <div className="text-center" data-id="element-290">
              <a href="#comprar" className="text-[13px] text-[#687280] no-underline hover:underline" data-id="element-291">
                Prefiero solo el libro — $9.97
              </a>
            </div>
          </div>

          {/* Closing phrase */}
          <p className="font-lora italic text-[14px] text-[#6B5B4E] text-center max-w-[480px] mx-auto mt-8" data-id="element-292">
            Tu único riesgo real es seguir sin el mapa.
          </p>
        </motion.div>
      </div>
    </section>;
}